// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1kX79","app_dark":"App_app_dark__2X-40"};